<!--
 * @Author: zxf
 * @Date: 2022-07-20 18:18:58
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:23:55
 * @Description: 消防检测会议新增
-->

<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        检测会议新增
      </h2>
      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <k-button
          btn-text="保存"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        />

        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->
    <!-- 内容页标题 -->

    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <el-form
          ref="fd"
          :inline="true"
          label-suffix="："
          :model="fd"
          :rules="fdRules"
          label-position="right"
          label-width="160px"
          class="c-form"
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              首次会议
            </el-col>

            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model="fd.xmmc"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入项目名称"
                />
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议标题"
                prop="firsthybt"
              >
                <el-input
                  v-model="fd.firsthybt"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入会议标题"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议日期"
                prop="firsthyrq"
              >
                <el-date-picker
                  v-model="fd.firsthyrq"
                  value-format="timestamp"
                  placeholder="选择会议日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议内容"
                prop="firsthynr"
              >
                <el-input
                  v-model="fd.firsthynr"
                  class="c-form__input"
                  type="textarea"
                  rows="4"
                  placeholder="请输入会议内容"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="签到表"
                prop="htFileId"
              >
                <file-serve-upload
                  ref="htsmjFileUpload"
                  v-model="fd.htFileId"
                  class="u-inline-block"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="application/pdf,application/msword,.doc,.docx"
                  :data="uploadFd"
                  :max-size="10 * 1024"
                >
                  <k-button
                    btn-text="上传"
                    :auth-type="true"
                    type="primary"
                    icon="kestrel-icon ki-cloud-upload"
                    plain
                  />
                  <span class="u-text-warning">（只能上传一份 doc / docx / pdf 文件，且不超过10M）</span>
                  <k-button
                    btn-text="下载模板"
                    :auth-type="true"
                    type="primary"
                    plain
                  />
                </file-serve-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="会议门面照片"
                prop="hymmPhoto"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.hymmPhoto"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="会议现场照片"
                prop="hyxcPhoto"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.hyxcPhoto"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="人员签到照片"
                prop="ryqdPhoto"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.ryqdPhoto"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="会议图片"
                prop="hytp"
              >
                <image-upload
                  ref="attrs"
                  v-model="fd.hytp"
                  multiple-file
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="image/*"
                  :data="uploadFd"
                  list-type="picture-card"
                >
                  <i
                    slot="default"
                    class="el-icon-plus"
                  />
                </image-upload>
              </el-form-item>
            </el-col>

            <!-- <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              合同信息
            </el-col> -->
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              执业过程
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="原始记录上传"
                prop="ysjlUpload"
              >
                <file-serve-upload
                  ref="htsmjFileUpload"
                  v-model="fd.ysjlUpload"
                  class="u-inline-block"
                  :file-api="$config.ctx.hmfileApi"
                  show-file-list
                  accept="application/pdf,application/msword,.doc,.docx"
                  :data="uploadFd"
                  :max-size="10 * 1024"
                >
                  <k-button
                    btn-text="附件上传"
                    :auth-type="true"
                    type="primary"
                    icon="kestrel-icon ki-cloud-upload"
                    plain
                  /><br>
                  <span class="u-text-warning">（请上传pdf文件）</span>
                </file-serve-upload>
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              末次会议
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议标题"
                prop="lasthybt"
              >
                <el-input
                  v-model="fd.lasthybt"
                  class="c-form__input"
                  type="text"
                  placeholder="请输入会议标题"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议日期"
                prop="lasthyrq"
              >
                <el-date-picker
                  v-model="fd.lasthyrq"
                  value-format="timestamp"
                  placeholder="选择会议日期"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="24"
              class="c-form__col"
            >
              <el-form-item
                class="c-form__item"
                label="会议内容"
                prop="lasthynr"
              >
                <el-input
                  v-model="fd.lasthynr"
                  class="c-form__input"
                  type="textarea"
                  rows="4"
                  placeholder="请输入会议内容"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>
<script>
import { hyglService } from './hygl.service';
import config from '@/config.js';
export default ({
  name: 'AddHygl',
  data () {
    return {
      loading: false, // 页面loading状态
      jcnrXtList: null,
      /* 申请信息 Start */
      fd: {
        xmmc: null,
        hybt: null,
        firsthyrq: null,
        lasthyrq: null,
        firsthynr: null,
        lasthynr: null,
        firsthybt: null,
        htFileId: null,
        hymmPhoto: [],
        hyxcPhoto: [],
        ryqdPhoto: [],
        hytp: [],
        xcjcyDm: null
      },
      /* 申请信息 End */

      /** 表单验证规则 Start */
      fdRules: {
        xmmc: [
          this.$validUtils.required('项目名称'),
          this.$HMValidator.maxLength('项目名称', 300)
        ],
        firsthybt: [
          this.$validUtils.required('会议标题')
        ],
        lasthybt: [
          this.$validUtils.required('会议标题')
        ],
        firsthyrq: [
          this.$validUtils.required('会议日期')
        ],
        lasthyrq: [
          this.$validUtils.required('会议日期')
        ],
        htFileId: [
          this.$validUtils.required('签到表')
        ],
        firsthynr: [
          this.$validUtils.required('会议内容')
        ],
        lasthynr: [
          this.$validUtils.required('会议内容')
        ],
        hymmPhoto: [
          this.$HMValidator.required('会议门面照片')
        ],
        hyxcPhoto: [
          this.$HMValidator.required('会议现场照片')
        ],
        ryqdPhoto: [
          this.$HMValidator.required('人员签到照片')
        ],
        hytp: [
          this.$HMValidator.required('会议图片')
        ],
        ysjlUpload: [
          this.$HMValidator.required('原始记录上传')
        ]

      },
      /** 表单验证规则 End */
      /* 文件服务器对接参数 Start */
      prepareUrl: config.prepareUrl, // 上传预加载服务地址
      uploadUrl: config.uploadUrl, // 上传服务地址
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'htwj',
            value: null
          }
        ]
      }
      /* 文件服务器对接参数 END */
    };
  },
  computed: {
    /** 建筑类别 */
    jzlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JZLB_JC) {
        return enums.IFF_JZLB_JC;
      }
      return {};
    },
    /** 检测类型 */
    jzlxType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JCLX) {
        return enums.IFF_JCLX;
      }
      return {};
    },
    /** 签到类型 */
    qdlxType () {
      // const enums = this.$store.state.apiEnums.iffApi;
      // if (enums && enums.IFF_QDLX) {
      //   return enums.IFF_QDLX;
      // }
      // return {};
      return [{
        id: '0',
        text: 'GPS签到'
      }];
    },
    /** 检测内容类型 */
    // jcnrType () {
    //   const enums = this.$store.state.apiEnums.iffApi;
    //   if (enums && enums.IFF_JCNRLX) {
    //     return enums.IFF_JCNRLX;
    //   }
    //   return {};
    // },
    /** 检测范围类型 */
    jcfwType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JCFWLX) {
        return enums.IFF_JCFWLX;
      }
      return {};
    }

  },
  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
    },
    /**
     * 获取检测项状态
     */
    getXtJcnrList () {
      hyglService.getXtJcnrList()
        .then(rsp => {
          this.jcnrXtList = rsp.data;
        })
        .catch(err => {
          console.error('获取系统检测内容信息失败！', err);
        });
    },

    /**
     * @description: 消防客户信息保存
     * @return {*}
     * @param {*} p
     */
    handleSave () {
      const _this = this;
      _this.$refs.fd.validate((valid) => {
        if (valid) {
          _this.loading = true;

          hyglService.save(_this.fd)
            .then(rsp => {
              _this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              _this.fd.id = rsp.data.id;
              _this.closeNavTabAndTo({
                name: 'hyglIndex',
                params: { isRefresh: true }
              }, true);
            })
            .catch(err => {
              console.error('消防会议新增出错！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      });
    }
  },
  created () {
    // this.init();
    // this.getXtJcnrList();
  }
});
</script>
